document.addEventListener('DOMContentLoaded',function(){setTimeout(function(){initStickyAddToCart()},500);function initStickyAddToCart(){const stickyElement=document.getElementById('stickyAddToCart');if(!stickyElement)return;

function findOriginalATCButton(){
  const selectors=['button[name="add"]','button.product-form__submit','button.product-form__cart-submit'];
  for(const sel of selectors){
    const btns=document.querySelectorAll(sel);
    for(const b of btns){
      if(b.closest('#stickyAddToCart'))continue;
      const r=b.getBoundingClientRect();
      if(r.width>0&&r.height>0)return b;
    }
  }
  return null;
}

// ── Fecha de entrega por país (misma lógica que el banner) ──
const shippingTimes={
  US:[10,15],MX:[10,15],PR:[20,30],CH:[10,15],IL:[18,25],
  ES:[10,15],CL:[18,25],DK:[8,15],FR:[8,15],IT:[8,15],
  PE:[18,25],JP:[10,20],BE:[8,15],CO:[18,25],CA:[7,13],
  GB:[8,15],NO:[8,15],IE:[8,15],PT:[8,15],BG:[10,15]
};
const months=['enero','febrero','marzo','abril','mayo','junio',
  'julio','agosto','septiembre','octubre','noviembre','diciembre'];

function formatDateRange(startDays,endDays){
  const now=new Date();
  const s=new Date(now.getTime()+startDays*86400000);
  const e=new Date(now.getTime()+endDays*86400000);
  if(s.getMonth()===e.getMonth()){
    return s.getDate()+'–'+e.getDate()+' de '+months[s.getMonth()];
  }
  return s.getDate()+' '+months[s.getMonth()]+' al '+e.getDate()+' de '+months[e.getMonth()];
}

function updateDeliveryDates(startDays,endDays){
  document.querySelectorAll('.delivery-date').forEach(el=>{
    el.textContent=formatDateRange(startDays,endDays);
  });
}

// Cargar fecha por IP
fetch('https://ipapi.co/json/')
  .then(r=>r.json())
  .then(data=>{
    const code=data.country_code||'US';
    const region=data.region||'';
    const isPR=region==='Puerto Rico';
    const range=isPR?shippingTimes['PR']:(shippingTimes[code]||[20,25]);
    updateDeliveryDates(range[0],range[1]);
  })
  .catch(()=>updateDeliveryDates(20,25));

// ── Scroll handler ──
let addToCartButton=findOriginalATCButton();
if(!addToCartButton){
  const obs=new MutationObserver(function(){
    const btn=findOriginalATCButton();
    if(btn){addToCartButton=btn;obs.disconnect();setupScrollHandler();}
  });
  obs.observe(document.body,{childList:true,subtree:true});
  setTimeout(()=>obs.disconnect(),10000);
}else{setupScrollHandler();}

function setupScrollHandler(){
  let isVisible=false;
  let debounceTimer=null;

  function getButtonOffsetTop(){
    if(!addToCartButton)return 9999;
    let el=addToCartButton,top=0;
    while(el){top+=el.offsetTop||0;el=el.offsetParent;}
    return top;
  }

  const buttonOffsetTop=getButtonOffsetTop();

  function handleScroll(){
    const scrollY=window.scrollY||window.pageYOffset;
    const windowHeight=window.innerHeight;
    const buttonHeight=addToCartButton?addToCartButton.offsetHeight:50;
    const shouldBeVisible=scrollY>(buttonOffsetTop+buttonHeight-windowHeight+50);

    const cartDrawerWrapper=document.querySelector('cart-drawer.drawer,.drawer.cart-drawer,.cart-drawer');
    const cartSidebar=document.querySelector('#sidebar-cart,#CartDrawer,.cart-sidebar');
    const isCartOpen=(cartDrawerWrapper&&(cartDrawerWrapper.classList.contains('active')||cartDrawerWrapper.classList.contains('is-open')||cartDrawerWrapper.hasAttribute('open')||cartDrawerWrapper.getAttribute('aria-hidden')==='false'))||(cartSidebar&&(cartSidebar.classList.contains('is-open')||cartSidebar.getAttribute('aria-hidden')==='false'));
    if(isCartOpen){hideStickyButton();return;}

    if(shouldBeVisible!==isVisible){
      clearTimeout(debounceTimer);
      debounceTimer=setTimeout(()=>{
        if(shouldBeVisible){showStickyButton();}
        else{hideStickyButton();}
      },50);
    }
  }

  function showStickyButton(){if(isVisible)return;stickyElement.style.display='block';void stickyElement.offsetWidth;stickyElement.classList.add('show');isVisible=true;}
  function hideStickyButton(){if(!isVisible)return;stickyElement.classList.remove('show');setTimeout(()=>{if(!stickyElement.classList.contains('show')){stickyElement.style.display='none';}isVisible=false;},400);}

  window.addEventListener('scroll',handleScroll,{passive:true});
  window.addEventListener('resize',handleScroll,{passive:true});
  document.addEventListener('cart:open',handleScroll);
  document.addEventListener('cart-drawer:open',handleScroll);
  const drawerObserver=new MutationObserver(()=>handleScroll());
  document.querySelectorAll('cart-drawer,#sidebar-cart,#CartDrawer,.cart-drawer').forEach(d=>drawerObserver.observe(d,{attributes:true}));
  setTimeout(handleScroll,300);
  setInterval(handleScroll,2000);
}
}});

function scrollToTop(e){e.preventDefault();window.scrollTo({top:0,behavior:'smooth'});}
window.scrollToTop=scrollToTop;
// v5 - 17jun2026